import { FusePageSimple } from '@fuse';
import { withStyles } from 'material-ui/styles';
import React, { Component } from 'react';

import { SelectFormsy, TextFieldFormsy } from '@fuse';
import Formsy from 'formsy-react';
import $ from "jquery";
import { Button, Divider, MenuItem } from 'material-ui';
import Checkbox from 'material-ui/Checkbox';
import Icon from 'material-ui/Icon';
import IconButton from 'material-ui/IconButton';
import TextField from 'material-ui/TextField';
import Loader from "other-components/loader/loader";
import Select from 'react-select';
import 'react-select/dist/react-select.css';

import axios from 'axios';
import Card, { CardContent } from 'material-ui/Card';
import Tooltip from 'material-ui/Tooltip';

import DayPickerInput from 'react-day-picker/DayPickerInput';
import ReactTable from "react-table";

import { withAlert } from 'react-alert';

const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64
    },
    tabRoot: {
        height: 64
    },
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
});

var currentDate = null;

// var paymentModeAr = [];

const tdStyle = { 'width': '14.285714%' };

class receipt extends Component {

    state = {
        value: 0,
    };

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            refNo: "",
            loadCustomerTypes: [],
            loadBanks: [],
            selectedType: 0,
            selectedPaymentType: 0,
            selectedCode: 0,
            customerCode: '',
            loadCustomerCode: [],
            loadCustomerName: [],
            loadCustomerNames: [],
            custname: '',
            devAmount: 0,
            loading: true,
            canAddRecord: false,
            receiptObjS: null,
            inputPayment: 0,

            selectedBank: '',
            bankAccountNumbers: [],

            paymentDataView: [],
            paymentDataViewTable: [],

            // payment method cards hidden
            cashCardHidden: true,
            cardCardHidden: true,
            cardChequeHidden: true,
            cardBankDepositHidden: true,

            paymentMode: {},

            paymentModeAr: [],

            checkInvo: true,

            loadPayTypes: [{ value: "1", label: "Cash" },
            { value: "3", label: "Card" },
            { value: "2", label: "Cheque" },
            { value: "4", label: "Bank Deposit" }],

            totalPayedAmount: 0,
            paymentModeArRowId: 0,
            totalOfPayedPaymentMode: 0,
            totalStable: 0
        };

        this.loadCustomerType();
        this.loadDate();
        this.loadBanks();

        this.getCustomerDetails = this.getCustomerDetails.bind(this);
        this.getCustomerNameById = this.getCustomerNameById.bind(this);
        this.loadPaymentTypes = this.loadPaymentTypes.bind(this);

        this.handleReceiptDateChange = this.handleReceiptDateChange.bind(this);
    }

    loadDate() {
        var date = new Date();
        var formatedDate = ((date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear()).toString();
        // alert(formatedDate);
        currentDate = formatedDate;
        // this.setState({
        //     formatedDate : formatedDate
        // });
    }

    handleReceiptDateChange(date) {
        console.log('changeDate', date);
        this.setState({
            receiptDate: date
        });
    }

    handleTextBoxChange = name => event => {
        this.setState({ [name]: event.target.value });
    };

    // load bank account numbers where bank
    loadBannkAccountNumers = (selectedOption) => {

        if (null == selectedOption) {
            this.setState({ selectedBank: '' });
        } else {
            this.setState({ selectedBank: selectedOption.value });

            var bankAccountNumbers = [];

            var bankName = {
                bankName: selectedOption.value
            }

            axios.post(window.accountServer + '/bank/loadBankAccountNumbers', bankName)
                .then(response => {

                    for (let i = 0; i < response.data.accountNumbers.length; i++) {

                        bankAccountNumbers.push({
                            label: response.data.accountNumbers[i].ACCOUNT_NO,
                            value: response.data.accountNumbers[i].ID_LEDGER_ACCOUNT
                        });
                    }
                    this.setState({ bankAccountNumbers: bankAccountNumbers });

                }).catch(function (error) {
                    console.log("err " + error);
                    console.log("No internet connection or Internal error");
                    // alert("No internet connection or Internal error");
                });
        }

    }

    // load customer details
    loadCustomerType() {
        this.setState({ loading: true });
        var loadCustomerType = [];

        axios.get(window.systemServer + '/system/loadCustomerTypes')
            .then(response => {

                var customerObj = window.DATABASE_TYPE == "MYSQL" ? response.data.result : response.data;
                for (var i = 0; i < customerObj.length; i++) {

                    loadCustomerType.push({
                        value: customerObj[i].customer_type,
                        label: customerObj[i].customer_type
                    });

                    console.log(customerObj[i].customer_type)
                }
                // }

                this.setState({ loadCustomerTypes: loadCustomerType });
                // $('#refNumber').val(this.state.refNo);

                this.setState({ loading: false });

            }).catch(function (error) {
                // alert(error);
                console.log("cust detail err " + error);
                console.log("No internet connection or Internal error");
                this.setState({ loading: false });
                // alert("No internet connection or Internal error");
            });
    }

    // get customer details when clicked customer type

    getCustomerDetails = (selectedOption) => {
        this.setState({ loading: true });

        var refNo = $('#refNumber').val();

        this.setState({ refNo: refNo });

        if (null == selectedOption || "" == selectedOption || undefined == selectedOption) {

            this.setState({ selectedType: "" });
            this.setState({ loading: false });
        } else {

            this.setState({ selectedType: selectedOption.value });

            var loadCustomerCode = [];
            var loadCustomerName = [];

            axios.post(window.crmServer + '/crm/getCustomer/byType', { type: selectedOption.value })
                .then(response => {
                    // if (response.data.success) {
                    var customerObj = window.DATABASE_TYPE == "MYSQL" ? response.data.result : response.data;
                    for (var i = 0; i < customerObj.length; i++) {

                        loadCustomerCode.push({
                            label: customerObj[i].CUSTOMER_CODE,
                            value: customerObj[i]._id
                        });

                        loadCustomerName.push({
                            label: customerObj[i].CUSTOMER_PROFILE.cx_name,
                            value: customerObj[i]._id
                        });

                        console.log(customerObj[i].CUSTOMER_PROFILE.cx_name);
                    }
                    // }

                    this.setState({ loadCustomerCode: loadCustomerCode });
                    this.setState({ loadCustomerNames: loadCustomerName });
                    this.setState({ loading: false });
                    $('#refNumber').val(this.state.refNo);

                    // reset tables
                    this.setState({
                        receiptObjS: null,
                        data: [],
                        selectedPaymentType: 0,
                        selectedCode: 0,
                        paymentDataView: [],
                        paymentDataViewTable: [],
                        paymentModeAr: [],
                    });


                }).catch(function (error) {
                    // alert(error);
                    console.log("cust detail err " + error);
                    console.log("No internet connection or Internal error");
                    this.setState({ loading: false });
                    // alert("No internet connection or Internal error");
                });
        }
    }

    // get customer name by customer id
    getCustomerNameById = (selectedOption) => {

        this.setState({ loading: true });

        if (null == selectedOption || "" == selectedOption || undefined == selectedOption) {

            this.setState({
                selectedCode: "",
                data: [],
                paymentDataViewTable: [],
                loading: false
            });
        } else {

            var refNo = $('#refNumber').val();
            this.setState({
                refNo: refNo,
                selectedCode: selectedOption.value,
                customerCode: selectedOption.label
            });

            var loadCustomerName = [];

            axios.post(window.crmServer + '/crm/getCustomer/byId', { id: selectedOption.value })

                .then(response => {
                    // if (response.data.success) {
                    var customerObj = response.data;

                    for (var i = 0; i < customerObj.length; i++) {

                        loadCustomerName.push({
                            value: customerObj[i].CUSTOMER_PROFILE.cx_name,
                            lable: customerObj[i].CUSTOMER_CODE
                        });
                    }
                    // }

                    this.setState({ loadCustomerName: loadCustomerName });

                    this.getInvoiceCustomer(selectedOption.value);

                    this.setState({ loading: false });
                    $('#refNumber').val(this.state.refNo);

                    // reset tables
                    this.setState({
                        receiptObjS: null,
                        data: [],
                        selectedPaymentType: 0,
                        // selectedCode: 0,
                        paymentDataView: [],
                        paymentDataViewTable: [],
                        paymentModeAr: [],
                    });

                }).catch(function (error) {
                    // alert(error);
                    console.log("cust detail err " + error);
                    console.log("No internet connection or Internal error");
                    this.setState({ loading: false });
                });
        }
    }

    // get invoice details where customer id
    getInvoiceCustomer(customerId) {

        this.setState({ loading: true });

        var data = [];
        axios.post(window.salesServer + '/receipt/getInvoiceByCustomer', { customerId: customerId })

            .then(response => {
                if (response.data.success) {
                    var invoiceObj = response.data.result;
                    if (invoiceObj.length > 0) {
                        for (var i = 0; i < invoiceObj.length; i++) {
                            var realInvoiceDate = (invoiceObj[i].BILL_DATE).split("T");
                            var devAmount = 0;
                            var lateChargeAsAmount = 0;

                            // set perment term date
                            var paymentTerm = null;
                            if (null == invoiceObj[i].PAYMENT_TERM_NET || undefined == invoiceObj[i].PAYMENT_TERM_NET || "" == invoiceObj[i].PAYMENT_TERM_NET) {
                                paymentTerm = invoiceObj[i].PAYMENT_TERM_BY;
                            } else {
                                paymentTerm = (invoiceObj[i].PAYMENT_TERM_NET).split("T")[0];
                            }

                            // set early payment discount
                            var earlyPayemetDiscount = 0;
                            var isEarlyPaymentPresentage = true;
                            var earlyDiscount = 0;

                            if (1 == invoiceObj[i].IS_EARLY_PAYMENT_DISCOUNT_PERCENTAGE) {
                                earlyPayemetDiscount = parseFloat(invoiceObj[i].EARLY_PAYMENT_DISCOUNT) + " %";
                                isEarlyPaymentPresentage = true;
                                earlyDiscount = parseFloat(invoiceObj[i].EARLY_PAYMENT_DISCOUNT);
                            } else {
                                earlyPayemetDiscount = parseFloat(invoiceObj[i].EARLY_PAYMENT_DISCOUNT) + "";
                                isEarlyPaymentPresentage = false;
                                earlyDiscount = parseFloat(invoiceObj[i].EARLY_PAYMENT_DISCOUNT);
                            }

                            // set late payment charge
                            var latePaymentCharge = 0;
                            var isLateChargePresentage = true;
                            var lateCharge = 0;

                            if (1 == invoiceObj[i].IS_LATE_PAYMENT_CHARGE_PERCENTAGE) {
                                latePaymentCharge = parseFloat(invoiceObj[i].LATE_PAYMENT_CHARGE) + " %";
                                isLateChargePresentage = true;
                                lateCharge = parseFloat(invoiceObj[i].LATE_PAYMENT_CHARGE);
                            } else {
                                latePaymentCharge = parseFloat(invoiceObj[i].LATE_PAYMENT_CHARGE) + "";
                                isLateChargePresentage = false;
                                lateCharge = parseFloat(invoiceObj[i].LATE_PAYMENT_CHARGE);
                            }

                            var date1 = new Date();
                            var date2 = new Date(paymentTerm);

                            if (null == date2 || undefined == date2 || "" == date2) {

                            } else {

                                var dateOf1 = date1.getDate();
                                var dateOf2 = date2.getDate();

                                var monthOf1 = date1.getMonth();
                                var monthOf2 = date2.getMonth();

                                var yearOf1 = date1.getYear();
                                var yearOf2 = date2.getYear();

                                var yearCount = (yearOf2 - yearOf1);
                                var monthCount = (monthOf2 - monthOf1);
                                var dateCount = (dateOf2 - dateOf1);
                                // alert(monthCount);
                                var totMonthCount = 0;

                                if (yearCount <= 0) {
                                    if (monthCount == 0) {
                                        if (dateCount <= 0) {
                                            totMonthCount = 0;
                                        } else {
                                            totMonthCount = monthCount;
                                        }
                                    } else {
                                        totMonthCount = monthCount;
                                    }
                                } else {
                                    totMonthCount = ((yearCount * 12) + monthCount);
                                }

                                if (totMonthCount > 0) {
                                    // this is early payment
                                    if (0 == earlyDiscount) {

                                        // if not early payment discount
                                        if (null == invoiceObj[i].DEV_AMOUNT || undefined == invoiceObj[i].DEV_AMOUNT || "" == invoiceObj[i].DEV_AMOUNT) {
                                            devAmount = invoiceObj[i].OUTSTANDING;
                                        } else {
                                            devAmount = invoiceObj[i].DEV_AMOUNT;
                                        }

                                    } else {

                                        // if has early payment discount
                                        if (isEarlyPaymentPresentage) {
                                            // if early payment discount is presentage
                                            var calEarlyDisc = ((parseFloat(invoiceObj[i].OUTSTANDING) * earlyDiscount) / 100) * totMonthCount;

                                            if (null == invoiceObj[i].DEV_AMOUNT || undefined == invoiceObj[i].DEV_AMOUNT || "" == invoiceObj[i].DEV_AMOUNT) {
                                                devAmount = (parseFloat(invoiceObj[i].OUTSTANDING) - calEarlyDisc);
                                            } else {
                                                devAmount = (parseFloat(invoiceObj[i].DEV_AMOUNT) - calEarlyDisc);
                                            }

                                        } else {
                                            // if early payment discount is amount
                                            var calEarlyDisc = (totMonthCount * earlyDiscount);

                                            if (null == invoiceObj[i].DEV_AMOUNT || undefined == invoiceObj[i].DEV_AMOUNT || "" == invoiceObj[i].DEV_AMOUNT) {
                                                devAmount = (parseFloat(invoiceObj[i].OUTSTANDING) - calEarlyDisc);
                                            } else {
                                                devAmount = (parseFloat(invoiceObj[i].DEV_AMOUNT) - calEarlyDisc);
                                            }
                                        }

                                    }

                                } else {
                                    // this is late payment

                                    if (0 == lateCharge) {
                                        // if not late charge
                                        if (null == invoiceObj[i].DEV_AMOUNT || undefined == invoiceObj[i].DEV_AMOUNT || "" == invoiceObj[i].DEV_AMOUNT) {
                                            devAmount = invoiceObj[i].OUTSTANDING;
                                        } else {
                                            devAmount = invoiceObj[i].DEV_AMOUNT;
                                        }

                                    } else {
                                        // if has late charge
                                        if (isLateChargePresentage) {
                                            // if late charge is presentage
                                            var calLateCharge = ((parseFloat(invoiceObj[i].OUTSTANDING) * lateCharge) / 100) * Math.abs(totMonthCount);
                                            lateChargeAsAmount = calLateCharge;

                                            if (null == invoiceObj[i].DEV_AMOUNT || undefined == invoiceObj[i].DEV_AMOUNT || "" == invoiceObj[i].DEV_AMOUNT) {
                                                devAmount = (parseFloat(invoiceObj[i].OUTSTANDING) + calLateCharge);
                                            } else {
                                                devAmount = (parseFloat(invoiceObj[i].DEV_AMOUNT) + calLateCharge);
                                            }

                                        } else {
                                            // if late charge is amount
                                            var calLateCharge = (Math.abs(totMonthCount) * lateCharge);
                                            lateChargeAsAmount = calLateCharge;

                                            if (null == invoiceObj[i].DEV_AMOUNT || undefined == invoiceObj[i].DEV_AMOUNT || "" == invoiceObj[i].DEV_AMOUNT) {
                                                devAmount = (parseFloat(invoiceObj[i].OUTSTANDING) + calLateCharge);
                                            } else {
                                                devAmount = (parseFloat(invoiceObj[i].DEV_AMOUNT) + calLateCharge);
                                            }
                                        }
                                    }
                                }
                            }

                            var realOutstand = 0;
                            if (0 >= invoiceObj[i].OUTSTANDING) {
                                realOutstand = 0;
                            } else {
                                realOutstand = invoiceObj[i].OUTSTANDING;
                            }

                            data.push({
                                rowId: i,
                                idInvoiceHeder: invoiceObj[i].ID_INVOICE_HEADER,
                                idReceiptHeder: invoiceObj[i].ID_RECEIPT_HEADER,
                                invoiceNo: invoiceObj[i].REFERENCE_NO,
                                customerId: invoiceObj[i].CUSTOMER_ID,
                                customerName: invoiceObj[i].CUSTOMER_NAME,
                                lateCharge: invoiceObj[i].LATE_PAYMENT_CHARGE,
                                grossAmount: invoiceObj[i].GROSS_AMOUNT,
                                netAmount: invoiceObj[i].NET_AMOUNT,
                                invoiceDate: realInvoiceDate[0],
                                paymentTermDate: paymentTerm,
                                // outStand: realOutstand,
                                outStand: devAmount.toFixed(2),
                                earlyPayemetDiscount: earlyPayemetDiscount,
                                // latePaymentCharge: latePaymentCharge,
                                latePaymentCharge: lateChargeAsAmount + " (" + latePaymentCharge + ")",
                                devAmount: devAmount.toFixed(2),
                                devAmountOriginal: devAmount.toFixed(2)
                            });
                        }
                        this.setState({ data: data });
                    } else {
                        // this.props.alert.error("No Invoice Data to Display");
                    }

                    this.setState({ loading: false });

                } else {

                    this.props.alert.error("Internal Error");
                    this.setState({ loading: false });
                }

            }).catch(function (error) {
                // alert("eere " + error);
                console.log("cust detail err " + error);
                console.log("No internet connection or Internal error");
                // alert("No intrnet connection or Internal error");
                this.setState({ loading: false });
            });
    }

    //
    updateOthers(ev, net, rowId) {

        var inputPayment = parseFloat(ev.target.value);
        console.log(inputPayment)
        this.setState({ inputPayment: inputPayment });
        var oldDevAmount = parseFloat(this.state.data[rowId].devAmountOriginal);


        if (null == inputPayment || 0 == inputPayment || undefined == inputPayment || "" == ev.target.value) {
            inputPayment = 0;
        }

        if (inputPayment > oldDevAmount) {

            // alert('worng input');
            this.props.alert.error("worng input !");
            $("#paymentVal" + rowId).val('');

            inputPayment = 0;

            var newDateAr1 = this.state.data.slice();
            newDateAr1[rowId].devAmount = oldDevAmount;
            this.setState({ data: newDateAr1 });
            newDateAr1[rowId].devAmountChange = false;

        } else {

            var genarateNewDevAmount = (oldDevAmount - inputPayment).toFixed(2);

            var newDateAr = this.state.data.slice();
            newDateAr[rowId].devAmount = genarateNewDevAmount;
            console.log(ev.target.value);
            if (0 == ev.target.value || "" == ev.target.value || null == ev.target.value || undefined == ev.target.value) {
                newDateAr[rowId].devAmountChange = false;
            } else {
                newDateAr[rowId].devAmountChange = true;
            }

            this.setState({ data: newDateAr });
        }
    }

    // select check box
    checkboxChecked(ev, outStand, idReceiptHeder, idInvoiceHeder, customerId, rowId, invoiceNo) {
        if (ev.target.checked) {

            var paymentDateView = [];
            var refNo = $('#refNumber').val();
            var paymentVal = $("#paymentVal" + rowId).val();
            var devAmountVal = $("#devAmount1" + rowId).val();
            var newOutstand = (parseFloat(outStand) - parseFloat(paymentVal));
            var receiptObj = {
                canAddRecord: true,
                invoiceNo: invoiceNo,
                payment: paymentVal,
                outStand: newOutstand,
                devAmount: devAmountVal,
                idReceiptHeder: idReceiptHeder,
                idInvoiceHeder: idInvoiceHeder,
                refNo: refNo,
                customerId: customerId
            };

            // set to payemet data view table
            paymentDateView.push(receiptObj);

            this.setState(prevState => ({
                paymentDataView: [...prevState.paymentDataView, receiptObj]
            }));

            this.setState({ receiptObjS: receiptObj });
        } else {
            this.setState({ receiptObjS: null });
        }
    }

    // add paid invoice to table
    addPaidInvoic() {

        var viewPaymentData = this.state.paymentDataView;
        console.log("viewPaymentData ", viewPaymentData);
        var paymentDataViewTable = [];

        if (0 == viewPaymentData.length || null == viewPaymentData || undefined == viewPaymentData) {

            this.props.alert.info("Please Input payment and select row !");
        } else {

            var totalPayedAmount = 0;

            for (var i = 0; i < viewPaymentData.length; i++) {

                totalPayedAmount = totalPayedAmount + parseFloat(viewPaymentData[i].payment);

                paymentDataViewTable.push({
                    rowIdp: i,
                    idInvoiceHederp: viewPaymentData[i].idInvoiceHeder,
                    idReceiptHederp: viewPaymentData[i].idReceiptHeder,
                    invoiceNop: viewPaymentData[i].invoiceNo,
                    customerIdp: viewPaymentData[i].customerId,
                    paymentp: viewPaymentData[i].payment
                });

            }
            this.setState({ paymentDataViewTable: paymentDataViewTable });
            this.setState({ totalPayedAmount: parseFloat(totalPayedAmount).toFixed(2) });
            this.setState({ totalStable: parseFloat(totalPayedAmount).toFixed(2) })
        }
    }

    // remove paid invoice to table
    removePaidInvoice(rowIdp) {

        var paidPaymentDataAr = this.state.paymentDataViewTable;

        console.log("////////// ", paidPaymentDataAr);

        var removedVal = parseFloat(paidPaymentDataAr[rowIdp].paymentp);
        console.log("////////// ", removedVal);

        paidPaymentDataAr.splice(rowIdp, 1);
        this.setState({ paymentDataViewTable: paidPaymentDataAr });

        var oldTotal = this.state.totalPayedAmount;
        var newTotal = (oldTotal - removedVal);
        this.setState({ totalPayedAmount: parseFloat(newTotal).toFixed(2) });
    }

    // hidden payment methods cards

    loadPaymentTypes = (selectedOption) => {

        if (null == selectedOption || "" == selectedOption || undefined == selectedOption) {

            this.setState({
                selectedPaymentType: "",
                cashCardHidden: true,
                cardCardHidden: true,
                cardChequeHidden: true,
                cardBankDepositHidden: true
            });

        } else {
            var selectPaymentType = selectedOption.value;

            this.setState({ selectedPaymentType: selectPaymentType });

            if ("1" == selectPaymentType) {
                this.setState({
                    cashCardHidden: false,
                    cardCardHidden: true,
                    cardChequeHidden: true,
                    cardBankDepositHidden: true
                });
            }

            if ("3" == selectPaymentType) {
                this.setState({
                    cardCardHidden: false,
                    cashCardHidden: true,
                    cardChequeHidden: true,
                    cardBankDepositHidden: true
                });
            }

            if ("2" == selectPaymentType) {
                this.setState({
                    cardChequeHidden: false,
                    cashCardHidden: true,
                    cardCardHidden: true,
                    cardBankDepositHidden: true,
                });
            }

            if ("4" == selectPaymentType) {
                this.setState({
                    cardBankDepositHidden: false,
                    cashCardHidden: true,
                    cardCardHidden: true,
                    cardChequeHidden: true,
                });
            }
        }

    }

    // add cash details to table
    addCashAmountT = (model) => {
        var cashAmount = model.cashAmount;
        if (cashAmount < 0) {
            this.props.alert.info("Cannot add minus values");
        } else {

            this.state.paymentModeArRowId = this.state.paymentModeArRowId + 1;
            var paymentMode = {}

            paymentMode.rowIdpm = this.state.paymentModeArRowId;
            paymentMode.paymentType = "1";
            paymentMode.paymentTypeName = "Cash";
            paymentMode.cardType = "";
            paymentMode.bank = "";
            paymentMode.branch = "";
            paymentMode.accountNo = "";
            paymentMode.cardNo = "";
            paymentMode.chequeNo = "";
            paymentMode.cardExpireDate = "";
            paymentMode.depositDate = "";
            paymentMode.slipNo = "";
            paymentMode.number = "";
            paymentMode.date = "";
            paymentMode.paymentAmount = cashAmount;

            var reduiceTotal = parseFloat(this.state.totalPayedAmount) - parseFloat(cashAmount);
            if (0 <= reduiceTotal) {
                this.setState({ totalPayedAmount: reduiceTotal.toFixed(2) });
                this.setState(prevState => ({
                    paymentModeAr: [...prevState.paymentModeAr, paymentMode]
                }));

                this.setState({
                    cashCardHidden: true,

                });
                document.getElementById("cashForm").reset();

            } else {
                this.props.alert.info("Big value");
            }

        }

    };

    // add card details to table
    addCardAmountT = (model) => {

        var cardType = model.cardType;
        var bankName = model.bankName;
        var cardNo = model.cardNo;
        var amount = model.amount;

        if (amount < 0) {
            this.props.alert.info("Cannot add minus values");
        } else {

            this.state.paymentModeArRowId = this.state.paymentModeArRowId + 1;
            var paymentMode = {}

            paymentMode.rowIdpm = this.state.paymentModeArRowId;
            paymentMode.paymentType = "3";
            paymentMode.paymentTypeName = "Card";
            paymentMode.cardType = model.cardType;
            paymentMode.bank = bankName;
            paymentMode.branch = "";
            paymentMode.accountNo = "";
            paymentMode.cardNo = cardNo;
            paymentMode.number = cardNo;
            paymentMode.chequeNo = "";
            paymentMode.cardExpireDate = model.expiredDate;
            paymentMode.depositDate = "";
            paymentMode.slipNo = "";
            paymentMode.date = model.expiredDate;
            paymentMode.paymentAmount = amount;

            var reduiceTotal = parseFloat(this.state.totalPayedAmount) - parseFloat(amount);
            if (0 <= reduiceTotal) {
                this.setState({ totalPayedAmount: reduiceTotal.toFixed(2) });
                this.setState(prevState => ({
                    paymentModeAr: [...prevState.paymentModeAr, paymentMode]
                }))

                this.setState({ cardCardHidden: true });
                document.getElementById("cardForm").reset();
            } else {
                this.props.alert.info("Big value");
            }
        }
    };

    // add cheque Details to table
    addChequeAmountT = (model) => {

        var bankName = model.bankName;
        var chequeNo = model.chequeNo;
        var accountNo = model.accountNo;
        var chequeDate = model.chequeDate;
        var amount = model.amount;

        if (amount < 0) {
            this.props.alert.info("Cannot add minus values");
        } else {
            this.state.paymentModeArRowId = this.state.paymentModeArRowId + 1;
            var paymentMode = {}

            paymentMode.rowIdpm = this.state.paymentModeArRowId;
            paymentMode.paymentType = "2";
            paymentMode.paymentTypeName = "Cheque";
            paymentMode.cardType = "";
            paymentMode.bank = this.state.selectedBank;
            paymentMode.branch = "";
            paymentMode.accountNo = accountNo;
            paymentMode.cardNo = "";
            paymentMode.number = chequeNo;
            paymentMode.chequeNo = chequeNo;
            paymentMode.cardExpireDate = "";
            paymentMode.depositDate = "";
            paymentMode.slipNo = "";
            paymentMode.date = chequeDate;
            paymentMode.paymentAmount = amount;

            var reduiceTotal = parseFloat(this.state.totalPayedAmount) - parseFloat(amount);
            if (0 <= reduiceTotal) {
                this.setState({ totalPayedAmount: reduiceTotal.toFixed(2) });
                this.setState(prevState => ({
                    paymentModeAr: [...prevState.paymentModeAr, paymentMode]
                }));

                this.setState({ cardChequeHidden: true });
                document.getElementById("chequeForm").reset();
            } else {
                this.props.alert.info("Big value");
            }
        }
    }

    // add bank Details to table
    addBankDepositAmountT = (model) => {

        var bankName = model.bankName;
        var branch = model.branch;
        var receiptNo = model.receiptNo;
        var depositDate = model.depositDate;
        var amount = model.amount;

        if (amount < 0) {
            this.props.alert.info("Cannot add minus values");
        } else {
            this.state.paymentModeArRowId = this.state.paymentModeArRowId + 1;
            var paymentMode = {}

            paymentMode.rowIdpm = this.state.paymentModeArRowId;
            paymentMode.paymentType = "4";
            paymentMode.paymentTypeName = "Bank";
            paymentMode.cardType = "";
            paymentMode.bank = bankName;
            paymentMode.branch = model.branch;
            paymentMode.accountNo = "";
            paymentMode.cardNo = "";
            paymentMode.number = receiptNo;
            paymentMode.chequeNo = "";
            paymentMode.cardExpireDate = "";
            paymentMode.depositDate = depositDate;
            paymentMode.slipNo = receiptNo;
            paymentMode.date = depositDate;
            paymentMode.paymentAmount = amount;


            var reduiceTotal = parseFloat(this.state.totalPayedAmount) - parseFloat(amount);
            if (0 <= reduiceTotal) {

                this.setState({ totalPayedAmount: reduiceTotal.toFixed(2) });
                this.setState(prevState => ({
                    paymentModeAr: [...prevState.paymentModeAr, paymentMode]
                }));

                this.setState({ cardBankDepositHidden: true });
                document.getElementById("bankForm").reset();
            } else {
                this.props.alert.info("Big value");
            }
        }
    }

    // romove payment mode
    removePaymentMode(rowId, paymentAmount) {

        // var paidPaymentModeAr = this.state.paymentModeAr;
        // var removedVal = parseFloat(paymentAmount);

        // paidPaymentModeAr.splice(rowId, 1);
        // this.setState({ paymentModeAr: paidPaymentModeAr });

        // var oldTotal = this.state.totalOfPayedPaymentMode;
        // var newTotal = (oldTotal - removedVal);
        // this.setState({ totalOfPayedPaymentMode: newTotal });

        var paidPaymentModeAr = this.state.paymentModeAr;
        var index = paidPaymentModeAr.findIndex(x => x.rowIdpm == rowId);
        var removedVal = parseFloat(paymentAmount);

        paidPaymentModeAr.splice(index, 1);
        this.setState({ paymentModeAr: paidPaymentModeAr });

        var oldTotal = this.state.totalOfPayedPaymentMode;
        var newTotal = (oldTotal - removedVal);
        var newPaymentTot = parseFloat(this.state.totalPayedAmount) + removedVal;


        this.setState({ totalPayedAmount: newPaymentTot.toFixed(2) });
        this.setState({ totalOfPayedPaymentMode: newTotal });

    }

    // save receipt
    saveReceipt() {
        this.setState({ loading: true });
        if (null != this.state.receiptDate || undefined != this.state.receiptDate) {
            var refNo = $("#refNumber").val();

            var paymentDataAr = this.state.paymentDataView;
            var paymentModeAr = this.state.paymentModeAr;

            var totalOfPayedPaymentMode = 0;

            for (var j = 0; j < paymentModeAr.length; j++) {
                totalOfPayedPaymentMode = totalOfPayedPaymentMode + parseFloat(paymentModeAr[j].paymentAmount);

            }

            this.setState({ totalOfPayedPaymentMode: totalOfPayedPaymentMode });

            var receiptArObj = {
                coustomerCode: this.state.customerCode,
                // coustomerCode: this.state.custname,
                total: this.state.totalStable,
                repDate: this.state.receiptDate,
                refNo: refNo,
                paymentDataAr: paymentDataAr,
                paymentModeAr: paymentModeAr
            }
            if (null == paymentDataAr || undefined == paymentDataAr || 0 == paymentDataAr.length) {

                this.props.alert.info("No Payment Data to Save. Please Select invoice Row First !");
                this.setState({ loading: false });
            } else {

                if (null == paymentModeAr || undefined == paymentModeAr || 0 == paymentModeAr.length) {
                    this.props.alert.info("No Selected Mode to Save. Please Select Payment Mode First !");
                    this.setState({ loading: false });
                } else {

                    // if (this.state.totalPayedAmount > totalOfPayedPaymentMode) {
                    if (this.state.totalPayedAmount == 0) {

                        axios.post(window.salesServer + '/receipt/saveReceipt', receiptArObj)
                            // axios.post('http://localhost:5006/receipt/saveReceipt', receiptArObj)
                            .then(response => {
                                if (response.data.success) {

                                    this.setState({ loading: false });
                                    // alert('success');
                                    this.props.alert.success("Payment Saved Successfully");
                                    this.setState({ receiptObjS: null });
                                    var custId = $("#custId").val();
                                    this.getInvoiceCustomer(custId);

                                    // reset tables
                                    this.setState({
                                        receiptObjS: null,
                                        selectedType: 0,
                                        refNo: '',
                                        data: [],
                                        selectedPaymentType: 0,
                                        selectedCode: 0,
                                        paymentDataView: [],
                                        paymentDataViewTable: [],
                                        paymentModeAr: [],
                                    })

                                    var address = null;
                                    axios.get(window.reportServer + '/report/get/reciept', {
                                        // axios.get('http://localhost:5008/report/get/reciept', {
                                        params: {
                                            refId: response.data.refId
                                        }
                                    }).then(response => {
                                        address = response.data.path;
                                        address = window.reportServer + "/" + address;

                                        //alert(address);
                                        //this.setState({ address: address });

                                        const url = address;
                                        window.open(url, '_blank');

                                    });

                                } else {
                                    this.props.alert.error("Cannot saved this payment");
                                    this.setState({ loading: false });
                                }

                            }).catch(function (error) {
                                // alert(error);
                                console.log("cust detail err " + error);
                                console.log("No internet connection or Internal error");
                                this.setState({ loading: false });
                                // alert("No internet connection or Internal error");
                            });
                    } else {
                        this.props.alert.info("Amount is incorrect");
                        this.setState({ loading: false });
                    }
                }
            }
        } else {
            this.props.alert.info("Select Date 1st !");
            this.setState({ loading: false });
        }
    }

    // load banks
    loadBanks() {
        var loadBanks = [];

        axios.get(window.systemServer + '/system/loadBanks')
            .then(response => {
                if (window.DATABASE_TYPE == "MYSQL")
                    for (let i = 0; i < response.data.result.length; i++) {
                        loadBanks.push({
                            label: response.data.result[i].bank_name,
                            value: response.data.result[i].bank_name
                        });
                    }
                else
                    for (let i = 0; i < response.data.length; i++) {
                        loadBanks.push({
                            label: response.data[i].bank_name,
                            value: response.data[i].bank_name
                        });
                    }
                this.setState({ loadBanks: loadBanks });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    render() {

        const { classes } = this.props;
        if (this.state.loading) {
            return (

                <Loader />

            );
        } else {

            return (

                <FusePageSimple
                    classes={{
                        root: classes.layoutRoot
                    }}

                    contentToolbar={
                        <div className="px-24 subtitle-color"><h2>New Receipt</h2></div>
                    }
                    content={
                        <div className="p-24 {classes.root}">
                            {/* <Formsy
                            id="genaralDetailForm"
                            onValidSubmit={this.onSubmit}
                            onValid={this.enableButton}
                            onInvalid={this.disableButton}
                            ref={(form) => this.form = form}
                            className="flex flex-col justify-center"
                        > */}
                            <div className="p-4 {classes.root} ">

                                <div className="flex flex-wrap -mx-3 mb-6 ">
                                    {/* <label className="w-full md:w-1/3 mt-24 pr-24 text-red">Receipt Date : {currentDate}</label> */}

                                    <div className="w-full md:w-1/5 inline-block  ">

                                        {this.state.receiptDate && <p >Receipt Date</p>}
                                        {!this.state.receiptDate && <p>Receipt Date</p>}
                                        <DayPickerInput
                                            className="bg-orange z-0"
                                            onDayChange={this.handleReceiptDateChange}
                                            selectedDays={this.state.receiptDate}
                                            value={this.state.receiptDate}
                                            onChange={this.handleTextBoxChange('receiptDate')}
                                        />
                                    </div>

                                    <TextField
                                        className="w-full md:w-1/5 "
                                        type="text"
                                        id="refNumber"
                                        name="refNumber"
                                        label="Ref-No"
                                        required
                                    />

                                </div>
                                <Divider className="md:mt-16 sm:mt-8" />
                                <div className="flex flex-wrap -mx-3 mb-6">

                                    <Select
                                        className="w-full md:w-1/4  mt-24 pr-24"
                                        name="form-field-name"
                                        placeholder="Select Customer Type"
                                        value={this.state.selectedType}
                                        onChange={this.getCustomerDetails}
                                        options={this.state.loadCustomerTypes}
                                    />

                                    <Select
                                        className="w-full md:w-1/4  mt-24 pr-24"
                                        name="form-field-name"
                                        placeholder="Select Customer Code"
                                        value={this.state.selectedCode}
                                        onChange={this.getCustomerNameById}
                                        options={this.state.loadCustomerCode}
                                    />

                                    <Select
                                        className="w-full md:w-1/4  mt-24 pr-24"
                                        name="form-field-name"
                                        placeholder="Select Customer Name"
                                        value={this.state.selectedCode}
                                        onChange={this.getCustomerNameById}
                                        options={this.state.loadCustomerNames}
                                    />


                                    {/* <div className="w-full md:w-1/6  mt-16"></div> */}

                                    {/* <div className="w-full md:w-1/4 mt-48 ml-24  pr-24">{this.state.loadCustomerName.map(function (item, i) {
                                        return <label className="text-red" value={item.value}>{item.value}</label>
                                    })}</div> */}

                                </div>

                            </div>
                            <div class="w-full bg-white h-auto mt-16">

                                <ReactTable
                                    getTrProps={(state, rowInfo, column) => {
                                        return {
                                            className: "cursor-pointer",
                                            onClick: (e, handleOriginal) => {

                                            }
                                        }
                                    }}
                                    data={this.state.data}
                                    columns={[
                                        {
                                            Header: "rowId",
                                            accessor: "rowId",
                                            show: false
                                        },

                                        {
                                            Header: "Invoice header Id",
                                            accessor: "idInvoiceHeder",
                                            show: false
                                        },
                                        {
                                            Header: "customerIdr Id",
                                            accessor: "customerId",
                                            show: false
                                        },
                                        {
                                            Header: "receipt header Id",
                                            accessor: "idReceiptHeder",
                                            show: false
                                        },
                                        {
                                            Header: "Invoice No",
                                            accessor: "invoiceNo",
                                            filterable: true,

                                        },
                                        {
                                            Header: "Invoice Date",
                                            accessor: "invoiceDate",
                                            filterable: true
                                        },
                                        {
                                            Header: "Term",
                                            accessor: "paymentTermDate",
                                            filterable: true
                                        },
                                        {
                                            Header: "Gross Amount",
                                            accessor: "grossAmount",
                                            show: false
                                        },
                                        {
                                            Header: "Net Amount",
                                            accessor: "netAmount",

                                        },
                                        {
                                            Header: "Outstanding",
                                            accessor: "outStand",
                                        },
                                        // {
                                        //     Header: "Early Disc.",
                                        //     accessor: "earlyPayemetDiscount",
                                        // },
                                        {
                                            Header: "Late Charge",
                                            accessor: "latePaymentCharge",
                                        },
                                        {
                                            Header: "Due Amount",
                                            accessor: "devAmount",
                                            // Cell: ({ row, original }) => (
                                            //     <div id={"devAmount1" + original.rowId}>
                                            //         {this.state.devAmount}

                                            //     </div>
                                            // ),
                                        },
                                        {
                                            Header: "Payment",
                                            accessor: "payment",

                                            Cell: ({ row, original }) => (
                                                <div>
                                                    <TextField
                                                        className="w-full"
                                                        id={"paymentVal" + original.rowId}
                                                        type="number"
                                                        name="paymentVal"
                                                        // value={original.rowId}
                                                        onChange={(ev) => { this.updateOthers(ev, original.netAmount, original.rowId) }}
                                                    />
                                                </div>
                                            ),
                                        },
                                        {
                                            Header: "Select",
                                            accessor: "select",
                                            Cell: ({ row, original }) => (
                                                <div>
                                                    <Checkbox
                                                        // checked={false}
                                                        id={"checkInvo" + original.rowId}
                                                        disabled={original.devAmountChange ? false : true}
                                                        value="checkedA"
                                                        onChange={(ev) => { this.checkboxChecked(ev, original.outStand, original.idReceiptHeder, original.idInvoiceHeder, original.customerId, original.rowId, original.invoiceNo) }}
                                                    />
                                                </div>
                                            ),
                                        }


                                    ]}
                                    defaultPageSize={5}
                                    className="-striped -highlight"
                                />
                            </div>
                            <div className="w-full md:w-5/6"></div>

                            <div className="w-full md:w-1/6 float-right mb-16">
                                <Button type="button" onClick={(e) => this.addPaidInvoic()} variant="raised" size="small" color="secondary" className="{classes.button} w-full mt-16">
                                    Add
                                </Button>

                            </div>

                            <div className="inline-flex">
                                <div className="w-full sm:w-1/2 md:w-2/3 p-8 inline-block bill-ayment-forn-margin">
                                    <div class="w-full bg-white h-auto mt-16 pay-mode-size">
                                        <h2 className="subtitle-color">Pay Mode</h2>

                                        <Select
                                            className="w-full md:w-1/4  mt-24 pr-24"
                                            name="form-field-name"
                                            placeholder="Select Pay Type"
                                            value={this.state.selectedPaymentType}
                                            onChange={this.loadPaymentTypes}
                                            options={this.state.loadPayTypes}
                                        />

                                        <div className="recept-total-margin">
                                            <table className="w-full border-collapse" style={{ 'border-collapse': 'collapse' }}>
                                                <tbody>
                                                    <td style={tdStyle}></td>
                                                    <td align="right" className="text-18" style={tdStyle}>
                                                        <lable className="recept-lable-font-size"> Total Pay Amount  :   <span>{this.state.totalPayedAmount}</span></lable>
                                                    </td>
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* <Select
                                        className="w-full md:w-1/6  mt-24 pr-24"
                                        name="customerType"
                                        label=""
                                        value={this.state.selectedPaymentType}
                                        onChange={this.loadPaymentTypes}
                                    >
                                        <MenuItem disabled value="none">
                                            <em>Select Payment Type</em>
                                        </MenuItem>
                                        <option value="cash">Cash</option>
                                        <MenuItem value="card">Card</MenuItem>
                                        <MenuItem value="cheque">Cheque</MenuItem>
                                        <MenuItem value="bank">Bank Deposit</MenuItem>
                                    </Select> */}
                                    </div>

                                    <div class="w-full bg-white h-auto mt-16" hidden={this.state.cashCardHidden}>
                                        <Card className={classes.card}>
                                            <CardContent>
                                                <h3>If Cash</h3>
                                                <div className="w-full">
                                                    <Formsy
                                                        id="cashForm"
                                                        onValidSubmit={this.addCashAmountT}
                                                        ref={(form) => this.form = form}
                                                    >
                                                        <div className="w-full md:w-1/3">
                                                            <TextFieldFormsy
                                                                className="w-full md:w-2/3 pr-24 mt-16"
                                                                type="number"
                                                                name="cashAmount"
                                                                label="Amount"
                                                                required
                                                            />

                                                            <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:w-1/3 pr-24">
                                                                Add
                                                            </Button>
                                                        </div>
                                                    </Formsy>
                                                </div>

                                            </CardContent>
                                        </Card>
                                    </div>


                                    <div class="w-full bg-white h-auto mt-16" hidden={this.state.cardCardHidden}>
                                        <Card className={classes.card}>
                                            <CardContent>
                                                <h3>If Card</h3>
                                                <div className="w-full">
                                                    <div className="w-full">
                                                        <Formsy
                                                            id="cardForm"
                                                            onValidSubmit={this.addCardAmountT}
                                                        >
                                                            <SelectFormsy
                                                                className="w-full md:w-1/6  mt-24 pr-24"
                                                                name="cardType"
                                                                label=""
                                                                value="none"
                                                                required
                                                            >
                                                                <MenuItem disabled value="none">
                                                                    <em>Card Type</em>
                                                                </MenuItem>
                                                                <MenuItem value="visa">Visa</MenuItem>
                                                                <MenuItem value="master">Master</MenuItem>

                                                            </SelectFormsy>

                                                            <SelectFormsy
                                                                className="w-full md:w-1/6  mt-24 pr-24"
                                                                name="bankName"
                                                                label=""
                                                                value="none"
                                                                required
                                                            >
                                                                <MenuItem disabled value="none">
                                                                    <em>Bank Name</em>
                                                                </MenuItem>
                                                                {/* <MenuItem value="boc">BOC</MenuItem>
                                                            <MenuItem value="peoples">People's</MenuItem> */}
                                                                {this.state.loadBanks.map(function (item, i) {
                                                                    return <MenuItem value={item.value}>{item.value}</MenuItem>;
                                                                })}

                                                            </SelectFormsy>

                                                            <TextFieldFormsy
                                                                className="w-full md:w-1/6  mt-12 pr-24"
                                                                type="text"
                                                                name="cardNo"
                                                                label="Card No"
                                                                required
                                                            />

                                                            <TextFieldFormsy
                                                                id="date"
                                                                label="Expired Date"
                                                                name="expiredDate"
                                                                type="text"
                                                                className="{classes.textField} w-full md:w-1/6 mt-12 pr-24"
                                                                required
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                            />

                                                            <TextFieldFormsy
                                                                className="w-full md:w-1/6  mt-12 pr-24"
                                                                type="number"
                                                                name="amount"
                                                                label="Amount"
                                                                required
                                                            />

                                                            <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:w-1/6 pr-24">
                                                                Add
                                                            </Button>
                                                        </Formsy>
                                                    </div>
                                                </div>
                                            </CardContent>
                                        </Card>
                                    </div>

                                    <div class="w-full bg-white h-auto mt-16" hidden={this.state.cardChequeHidden}>
                                        <Card className={classes.card}>
                                            <CardContent>
                                                <h3>If Cheque</h3>
                                                <div className="w-full md:w-5/6">
                                                    <Formsy
                                                        id="chequeForm"
                                                        onValidSubmit={this.addChequeAmountT}
                                                    >
                                                        <Select
                                                            className="w-full md:w-1/5  mt-24 pr-24"
                                                            name="form-field-name"
                                                            placeholder="Select Bank"
                                                            value={this.state.selectedBank}
                                                            onChange={this.loadBannkAccountNumers}
                                                            options={this.state.loadBanks}
                                                        />

                                                        {/* say shan */}
                                                        <TextFieldFormsy
                                                            className="w-full md:w-1/6  mt-12 pr-24"
                                                            type="number"
                                                            name="accountNo"
                                                            label="Account No"
                                                            required
                                                        />

                                                        <TextFieldFormsy
                                                            className="w-full md:w-1/5  mt-12 pr-24"
                                                            type="number"
                                                            name="chequeNo"
                                                            label="Cheque No"
                                                            validations={{
                                                                maxLength: 6
                                                            }}
                                                            validationErrors={{
                                                                maxLength: 'Max character length is 6'
                                                            }}
                                                            required
                                                        />

                                                        <TextFieldFormsy
                                                            id="date"
                                                            label="Cheque Date"
                                                            name="chequeDate"
                                                            type="date"
                                                            className="{classes.textField} w-full md:w-1/5 mt-12 pr-24"
                                                            required
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                        />

                                                        <TextFieldFormsy
                                                            className="w-full md:w-1/5  mt-12 pr-24"
                                                            type="number"
                                                            name="amount"
                                                            label="Amount"
                                                            required
                                                        />

                                                        <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:w-1/6 pr-24">
                                                            Add
                                                        </Button>
                                                    </Formsy>
                                                </div>
                                            </CardContent>
                                        </Card>
                                    </div>

                                    <div class="w-full bg-white h-auto mt-16" hidden={this.state.cardBankDepositHidden}>
                                        <Card className={classes.card}>
                                            <CardContent>
                                                <h3>If Bank Deposit</h3>
                                                <div className="w-full">
                                                    <Formsy
                                                        id="bankForm"
                                                        onValidSubmit={this.addBankDepositAmountT}
                                                    >

                                                        <SelectFormsy
                                                            className="w-full md:w-1/6  mt-24 pr-24"
                                                            name="bankName"
                                                            label=""
                                                            value="none"
                                                            required
                                                        >
                                                            <MenuItem disabled value="none">
                                                                <em>Bank Name</em>
                                                            </MenuItem>
                                                            {this.state.loadBanks.map(function (item, i) {
                                                                return <MenuItem value={item.value}>{item.value}</MenuItem>;
                                                            })}

                                                        </SelectFormsy>

                                                        <TextFieldFormsy
                                                            className="w-full md:w-1/6  mt-12 pr-24"
                                                            type="text"
                                                            name="branch"
                                                            label="Branch"
                                                            required
                                                        />

                                                        <TextFieldFormsy
                                                            id="date"
                                                            label="Deposit Date"
                                                            name="depositDate"
                                                            type="date"
                                                            className="{classes.textField} w-full md:w-1/6 mt-12 pr-24"
                                                            required
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                        />

                                                        <TextFieldFormsy
                                                            className="w-full md:w-1/6  mt-12 pr-24"
                                                            type="number"
                                                            name="receiptNo"
                                                            label="Receipt No"
                                                            required
                                                        />

                                                        <TextFieldFormsy
                                                            className="w-full md:w-1/6  mt-12 pr-24"
                                                            type="number"
                                                            name="amount"
                                                            label="Amount"
                                                            required
                                                        />

                                                        <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:w-1/6 pr-24">
                                                            Add
                                                        </Button>
                                                    </Formsy>
                                                </div>
                                            </CardContent>
                                        </Card>
                                    </div>
                                    <div class="w-full bg-white h-auto mt-48">
                                        <h2 className="subtitle-color payment-mode-title-margin">Payment Mode Details</h2>

                                        <ReactTable
                                            getTrProps={(state, rowInfo, column) => {
                                                return {
                                                    className: "cursor-pointer",
                                                    onClick: (e, handleOriginal) => {

                                                    }
                                                }
                                            }}
                                            data={this.state.paymentModeAr}
                                            columns={[
                                                {
                                                    Header: "rowId",
                                                    accessor: "rowIdpm",
                                                    width: 110,
                                                    show: false
                                                },

                                                {
                                                    Header: "Payment Type",
                                                    accessor: "paymentTypeName",
                                                    width: 130,
                                                    filterable: true
                                                },

                                                {
                                                    Header: "Bank",
                                                    accessor: "bank",
                                                    width: 120,
                                                    filterable: true
                                                },

                                                {
                                                    Header: "Cheque / Card No",
                                                    accessor: "number",
                                                    width: 150,
                                                    filterable: true
                                                },

                                                {
                                                    Header: "Date",
                                                    accessor: "date",
                                                    width: 100,
                                                    filterable: true
                                                },

                                                {
                                                    Header: "Amount",
                                                    accessor: "paymentAmount",
                                                    width: 100,
                                                    filterable: true
                                                },
                                                {
                                                    Header: "Action",
                                                    // accessor: "su",
                                                    width: 128,
                                                    Cell: row => (

                                                        <div className="flex items-center  w-8 h-8">
                                                            <Tooltip
                                                                enterDelay={300}
                                                                id="tooltip-controlled"
                                                                leaveDelay={300}
                                                                onClose={this.handleTooltipClose}
                                                                onOpen={this.handleTooltipOpen}
                                                                open={this.state.open}
                                                                placement="bottom"
                                                                title="Remove payment Mode"
                                                            >
                                                                <IconButton
                                                                    onClick={(e) => {
                                                                        if (row) {

                                                                            this.removePaymentMode(row.original.rowIdpm, row.original.paymentAmount);

                                                                        }
                                                                    }}

                                                                >
                                                                    <Icon className="text-red">cancel</Icon>
                                                                </IconButton>
                                                            </Tooltip>
                                                        </div>
                                                    )
                                                }

                                            ]}
                                            defaultPageSize={5}
                                            className="-striped -highlight"
                                        />
                                    </div>
                                </div>

                                <div className="w-full sm:w-1/2 md:w-1/3 p-8  inline-block">
                                    <div class="w-full bg-white h-auto mt-48">
                                        <h2 className="subtitle-color paild-invoice-title-margin">Paid Invoice</h2>
                                        <label className="w-full md:w-1/6 mt-24  pr-24">Transaction Date : {currentDate}</label>

                                        <ReactTable
                                            getTrProps={(state, rowInfo, column) => {
                                                return {
                                                    className: "cursor-pointer",
                                                    onClick: (e, handleOriginal) => {

                                                    }
                                                }
                                            }}
                                            data={this.state.paymentDataViewTable}
                                            columns={[
                                                {
                                                    Header: "rowId",
                                                    accessor: "rowIdp",
                                                    show: false
                                                },

                                                {
                                                    Header: "Invoice header Id",
                                                    accessor: "idInvoiceHederp",
                                                    show: false
                                                },
                                                {
                                                    Header: "customerIdr Id",
                                                    accessor: "customerIdp",
                                                    show: false
                                                },
                                                {
                                                    Header: "receipt header Id",
                                                    accessor: "idReceiptHederp",
                                                    show: false
                                                },
                                                {
                                                    Header: "Invoice No",
                                                    accessor: "invoiceNop",
                                                    filterable: true
                                                },
                                                {
                                                    Header: "Paid Amount",
                                                    accessor: "paymentp",
                                                    filterable: true
                                                },
                                                {
                                                    Header: "Action",
                                                    // accessor: "su",
                                                    width: 128,
                                                    Cell: row => (

                                                        <div className="flex items-center  w-8 h-8">
                                                            <Tooltip
                                                                enterDelay={300}
                                                                id="tooltip-controlled"
                                                                leaveDelay={300}
                                                                onClose={this.handleTooltipClose}
                                                                onOpen={this.handleTooltipOpen}
                                                                open={this.state.open}
                                                                placement="bottom"
                                                                title="Remove payment"
                                                            >
                                                                <IconButton
                                                                    onClick={(e) => {
                                                                        if (row) {

                                                                            this.removePaidInvoice(row.original.rowIdp);

                                                                        }
                                                                    }}

                                                                >
                                                                    <Icon className="text-red">cancel</Icon>
                                                                </IconButton>
                                                            </Tooltip>
                                                        </div>
                                                    )
                                                }

                                            ]}
                                            defaultPageSize={3}
                                            className="-striped -highlight"
                                        />

                                        {/* <div>
                                            <table className="w-full border-collapse" style={{ 'border-collapse': 'collapse' }}>
                                                <tbody>
                                                    <td style={tdStyle}></td>
                                                    <td align="right" className="text-18" style={tdStyle}>
                                                        Total : <span>{this.state.totalPayedAmount}</span>
                                                    </td>
                                                </tbody>
                                            </table>
                                        </div> */}

                                    </div>
                                </div>
                            </div>
                            <div className="w-full md:w-2/3"></div>

                            <div className="w-full md:w-1/4 float-right mb-16">
                                <Button type="button" onClick={(ev) => this.saveReceipt()} variant="raised" size="small" color="secondary" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 pr-24 -ml-24 mr-8">
                                    Save
                                </Button>

                                <Button type="button" onClick={this.resetForm} variant="raised" size="small" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 pr-24 mr-8">
                                    Clear
                                </Button>

                                <Button type="button" variant="raised" size="small" color="primary" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 pr-24">
                                    Help
                                </Button>
                            </div>
                        </div>
                    }
                />
            )
        }
    }

}


export default withStyles(styles, { withTheme: true })(withAlert(receipt));


// WEBPACK FOOTER //
// ./src/main/content/sales/receipt/receipt.js